import { useEffect } from 'react'

export default function SEO({ title, description, noindex }) {
    useEffect(() => {
        if (title) {
            document.title = title
            const ogTitle = document.querySelector('meta[property="og:title"]')
            if (ogTitle) ogTitle.content = title
            const twTitle = document.querySelector('meta[name="twitter:title"]')
            if (twTitle) twTitle.content = title
        }

        if (description) {
            let meta = document.querySelector('meta[name="description"]')
            if (meta) meta.content = description

            const ogDesc = document.querySelector('meta[property="og:description"]')
            if (ogDesc) ogDesc.content = description

            const twDesc = document.querySelector('meta[name="twitter:description"]')
            if (twDesc) twDesc.content = description
        }

        const setRobots = (selector, content) => {
            let meta = document.querySelector(selector)
            if (meta) meta.content = content
        }

        const indexing = noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        setRobots('meta[name="robots"]', indexing)
        setRobots('meta[name="googlebot"]', noindex ? 'noindex, nofollow' : 'index, follow')
        setRobots('meta[name="bingbot"]', noindex ? 'noindex, nofollow' : 'index, follow')
        setRobots('meta[name="yandex"]', noindex ? 'noindex, nofollow' : 'index, follow')

    }, [title, description, noindex])

    return null
}
